import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  container: {
    textAlign: 'center',
    position: 'fixed',
    left: '0',
    right: '0'
  },
  spinner: {
    position: 'fixed',
    top: '50%',
    right: '50%',
    marginTop: '-20px',
    marginRight: '-20px'
  }
});

const PageLoadSpinner = ({ classes }) => {
  return (
    <Box
      data-testid="loading-spinner"
      width="100%"
      height="100%"
      className={classes.container}
    >
      <CircularProgress className={classes.spinner} />
    </Box>
  );
};

PageLoadSpinner.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(PageLoadSpinner);
